<script lang="ts">
    import { _ } from "svelte-i18n";
    import { appManager } from "../../AppManagerStore";
    import Countup from "../../components/Countup.svelte";
</script>

<section class="pt-9 pt-md-12 bg-light" id="pricing">
    <div class="container py-5">
        <div class="row justify-content-center mb-7">
            <div class="col-12 col-md-10 col-lg-8 text-center">
                <h1 id="pricing">
                    {$_("communicate.pricing.title1")}
                    <div class="text-success d-inline">
                        {$_("communicate.pricing.title2")}
                    </div>
                    {$_("communicate.pricing.title3")}
                </h1>

                <p class="lead text-gray-700">
                    {$_("communicate.pricing.subtitle")}
                </p>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12 col-md-4">
                <div class="card shadow-lg mb-6 mb-md-0">
                    <div class="card-body">
                        <div class="text-center mb-3">
                            <span
                                class="badge badge-pill badge-primary-desat-soft">
                                <span class="h6 text-uppercase"
                                    >{$_(
                                        "communicate.pricing.trial.title"
                                    )}</span>
                            </span>
                        </div>

                        <div class="d-flex justify-content-center">
                            <span class="h2 mb-0 mt-2">€</span>
                            <span class="price display-2 mb-0">1800</span>
                        </div>

                        <p class="text-center text-muted mb-5">
                            {$_("communicate.pricing.trial.or")}<span class="align-self-end"
                            >{$_("general.permonth")}</span>
                        </p>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.trial.check1")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.trial.check2")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.trial.check3")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.trial.check4")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.trial.check5")}</p>
                        </div>

                        <div class="d-grid gap-2 mt-3">
                            <a
                                class="btn btn-block btn-primary"
                                href="{$appManager.PublicUrl}contact">
                                {$_("communicate.pricing.trial.get")}
                                <i class="fe fe-arrow-right ml-3" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4">
                <div class="card shadow-lg mb-6 mb-md-0">
                    <div class="card-body">
                        <div class="text-center mb-3">
                            <span
                                class="badge badge-pill badge-primary-desat-soft">
                                <span class="h6 text-uppercase"
                                    >{$_(
                                        "communicate.pricing.city.title"
                                    )}</span>
                            </span>
                        </div>

                        <div class="d-flex justify-content-center">
                            <span class="h2 mb-0 mt-2">€</span>
                            <span class="price display-2 mb-0"
                                >3000</span>
                        </div>

                        <p class="text-center text-muted mb-5">
                            {$_("communicate.pricing.city.or")}<span class="align-self-end"
                            >{$_("general.permonth")}</span>
                        </p>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.city.check1")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.city.check2")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.city.check3")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.city.check4")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.city.check5")}</p>
                        </div>

                        <div class="d-grid gap-2 mt-3">
                            <a
                                class="btn btn-block btn-primary"
                                href="{$appManager.PublicUrl}contact">
                                {$_("communicate.pricing.city.get")}
                                <i class="fe fe-arrow-right ml-3" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4">
                <div class="card shadow-lg mb-6 mb-md-0">
                    <div class="card-body">
                        <div class="text-center mb-3">
                            <span
                                class="badge badge-pill badge-primary-desat-soft">
                                <span class="h6 text-uppercase"
                                    >{$_(
                                        "communicate.pricing.world.title"
                                    )}</span>
                            </span>
                        </div>

                        <div class="d-flex justify-content-center">
                            <span class="h2 mb-0 mt-2">€</span>
                            <span class="price display-2 mb-0"
                                >5400</span>
                        </div>

                        <p class="text-center text-muted mb-5">
                            {$_("communicate.pricing.world.or")}<span class="align-self-end"
                            >{$_("general.permonth")}</span>
                        </p>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.world.check1")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.world.check2")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.world.check3")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.world.check4")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("communicate.pricing.world.check5")}</p>
                        </div>

                        <div class="d-grid gap-2 mt-3">
                            <a
                                class="btn btn-block btn-primary"
                                href="{$appManager.PublicUrl}contact">
                                {$_("communicate.pricing.world.get")}
                                <i class="fe fe-arrow-right ml-3" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
